// extracted by mini-css-extract-plugin
export var logo = "_iw-2";
export var logoWrapper = "_iw-1";
export var strip = "_iw-0";